﻿import { IProject } from "@/interfaces";
import { useUserContext } from "@/providers";
import { calculateIsUserProjectLeader } from "@/providers/helpers";

export function useIsProjectLeader(projectLoading: boolean, project: IProject) {
  const { userToken } = useUserContext();
  return calculateIsUserProjectLeader(projectLoading, project, userToken);
}
